<template>
    <div >
      <video ref="video" muted autoplay controls style="width: 100%;height: 100%;"></video>
    </div>
</template>

<script>
  import Hls from 'hls.js'

  export default {
    name: 'simpleVideo',
    data () {
      return {
        hls: new Hls()
      }
    },
    props: {
      hlsUrl: {}
    },
    watch: {
      hlsUrl: {
        deep: true,
        handler (cur) {
          console.error('hlsUrl', cur)
          this.initHlsVideo(cur)
        }
      }
    },
    mounted () {
      if (this.hlsUrl) {
        this.initHlsVideo(this.hlsUrl)
      }
    },
    methods: {
      initHlsVideo (src) {
        if (Hls.isSupported()) {
          this.hls = new Hls()
          this.hls.loadSource(src)
          this.hls.attachMedia(this.$refs.video)
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            console.log('加载成功', src)
            this.$refs.video.play()
            console.log('video play 成功')
          })
          this.hls.on(Hls.Events.ERROR, (event, data) => {
            console.log(event, data)
            // 监听出错事件
            console.log('加载失败')
          })
        } else if (this.$refs.video.canPlayType('application/vnd.apple.mpegurl')) {
          this.$refs.video.src = 'https://video-dev.github.io/streams/x36xhzz/x36xhzz.m3u8'
          this.$refs.video.addEventListener('loadedmetadata', () => {
            this.$refs.video.play()
          })
        }
      },
      close() {
        if (this.hls) {
          this.$refs.video.pause()
          this.hls.detachMedia(this.$refs.video)
          this.hls.stopLoad()
          this.hls.destroy()
        }
      }
    },
    beforeDestroy() {
      this.close()
    }
  }
</script>

<style scoped lang="less">
  .video-wrap{
    position: relative;
    width: 1000px;
    height: 670px;
  }
  .close{
    position: absolute;
    right: 10px;
    top: -40px;
    font-size: 16px;
    cursor: pointer;
  }
  .tab-wrap {
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .tab-item {
      margin: 5px 10px;
      padding: 6px;
      box-shadow: 0px 0px 1px 1px #f5f5f5;;
    }
    .active {
      box-shadow: 0px 0px 2px 2px green;
      transform: scale(1.05);
    }
  }
  .playback-wrap {
    box-sizing: border-box;
    padding: 0px 20px;
    animation: toggle 1s;
  }
  @keyframes toggle {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0%);
    }
  }
  .video-wrap {
    margin: 6px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/simpleVideo.vue